export default __webpack_public_path__ + "894f8b095c5a5f331ccd4c336e73db66.svg";